// @givmo/board — a board-only director page reached by a seat for someone who isn't on the board
// (CBG-YR6-OUTSIDE; review-215's F5).
//
// About the board, getting started, the disclosures and the year's questionnaire, the self-assessment
// and the copy of the return are the board's alone (backend contract §3.2, class B): the backend
// answers such a seat its one constant not-found whatever the page names. Its own pages never link
// here, but an address can — a forwarded link, a typed one. So the page says only that nothing is
// here, in the console's own not-found words, with the way back to its committees: no title of the
// board's page, no act that can't work, no "Try again" (CBG-FIX91), and no read goes out.

import { Card, CardBody, testIdProp } from '@givmo/design-system';
import { Link } from '../../board-routing';
import {
  directorBoardIdentity,
  useDirectorBoardAddress,
  wayHome,
} from '../../director/director-board';
import { committeeOnlyWords as co } from '../committees/committee-only-words';
import { DirectorShell } from './director-shell';

const BACK_LINK =
  'font-sans text-s14 font-w600 tracking-givmo text-brand-600 outline-none transition-colors hover:text-brand-700 focus-visible:underline';

/** The one not-found, under the page's own test id. */
export function DirectorBoardOnlyPage({ testId }: { testId: string }) {
  const { board, me, settled } = useDirectorBoardAddress();
  // CBG-FIX109: for one seat, the way back opens that seat's page and says so (`wayHome`), once
  // `/me` answers: until then, which page it opens and what it says aren't known.
  const home = wayHome(me, co.allYourCommittees);
  return (
    <DirectorShell
      title={co.pageNotFoundTitle}
      identity={directorBoardIdentity(board)}
      actions={
        settled ? (
          <Link
            to={home.to}
            search={home.search}
            exact
            className={BACK_LINK}
            {...testIdProp('director-board-only-back')}
          >
            {home.words}
          </Link>
        ) : undefined
      }
      testId={testId}
    >
      <Card testId="director-board-only">
        <CardBody>
          <p className="font-sans text-s15 font-w400 leading-h15 tracking-givmo text-text-secondary">
            {co.pageNotFoundLine}
          </p>
        </CardBody>
      </Card>
    </DirectorShell>
  );
}
